var t = Math.log,
  a = Math.LOG10E,
  o = Math.log10 || function (o) {
    return t(o) * a;
  };
export { o as m };